import {
  RestrictionType,
  PaymentExclusionOverrideSetting,
  isBuyerAccountInRestrictionList,
} from '@arc/unified-payments-frontend/shared-payment';
import {
  selectAllowACH,
  selectAllowCreditCard,
  selectIsBuyerAccountRestrictionEnabledForOriginSystem,
  selectPaymentInclusionExclusionRules,
} from '@arc/unified-payments-frontend/shared-stores';
import { createSelector } from '@ngrx/store';
import { selectAccountNumbers } from './pay-on-account.selectors';

export const selectPaymentExclusionOverrideSetting = createSelector(
  selectPaymentInclusionExclusionRules,
  selectAccountNumbers,
  selectIsBuyerAccountRestrictionEnabledForOriginSystem,
  (
    restrictionConfig,
    buyerAccountNumbers,
    isBuyerAccountRestrictionEnabledForOriginSystem,
  ) => {
    const restrictionType = restrictionConfig?.restrictionType;
    const result: PaymentExclusionOverrideSetting = {
      isBuyerAccountInRestrictionList: false,
      allowRestrictionOverride: false,
    };

    if (
      !isBuyerAccountRestrictionEnabledForOriginSystem ||
      !restrictionType ||
      restrictionType === RestrictionType.NoRestriction
    ) {
      return result;
    }

    // Check if any of the accounts are in the restriction lists
    const isAccountInRestrictionList = isBuyerAccountInRestrictionList(
      buyerAccountNumbers,
      restrictionConfig?.restrictionConfigurations,
      restrictionType,
    );

    result.isBuyerAccountInRestrictionList =
      (restrictionType === RestrictionType.Inclusion &&
        !isAccountInRestrictionList) ||
      (restrictionType === RestrictionType.Exclusion &&
        isAccountInRestrictionList);

    // Allow override only if the account is restricted and the override is allowed
    result.allowRestrictionOverride =
      result.isBuyerAccountInRestrictionList &&
      restrictionConfig?.overrideRestriction;

    return result;
  },
);

export const selectAllowCardOverride = createSelector(
  selectPaymentExclusionOverrideSetting,
  (state) => state.allowRestrictionOverride,
);

export const selectIsBuyerAccountRestricted = createSelector(
  selectPaymentExclusionOverrideSetting,
  (state) => state.isBuyerAccountInRestrictionList,
);

export const selectShowPaymentToggle = createSelector(
  selectAllowACH,
  selectAllowCreditCard,
  selectIsBuyerAccountRestricted,
  (acceptACH, acceptCreditCard, isBuyerAccountRestricted) => {
    return acceptACH && acceptCreditCard && !isBuyerAccountRestricted;
  },
);
